
export default {
  name: 'icon-share',
};
